"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  alphanumeric: 'Needs to be alphanumeric, containing only numbers and letters.',
  ascii: 'Not properly formatted.',
  phoneNumber: 'Not a properly formatted phone number.',
  email: 'Please enter a valid e-mail address.',
  boolean: 'Must be a boolean (yes/no, true/false, 1/0).',
  regex: 'Not properly formatted.',
  integer: 'Must be a non-negative integer.',
  date: 'Must be a valid date.',
  date_mm_dd_yyyy: "Must be formatted ".concat('mm/dd/yyyy', "."),
  dateTime: 'Must be formatted YYYY-MM-DD HH:mm:ss.',
  array: 'Must be a valid array.'
};
exports.default = _default;